<div class="table-wrapper">

  <table mat-table [dataSource]="requisitions" class="lab-table">
    <!-- srno -->
    <ng-container matColumnDef="srno">

      <th mat-header-cell *matHeaderCellDef>
        Sr No
      </th>

      <td mat-cell *matCellDef="let row; let i = index">
        {{ i + 1 }}
      </td>

    </ng-container>

    <!-- PATIENT -->

    <ng-container matColumnDef="patient">

      <th mat-header-cell *matHeaderCellDef>
        Patient
      </th>

      <td mat-cell *matCellDef="let row">

        <div class="patient-name">
          {{ row.patientName }}
        </div>

        <div class="patient-mobile">
          {{ row.mobileNumber }}
        </div>

      </td>

    </ng-container>

    <!-- DOCTOR -->

    <ng-container matColumnDef="doctor">

      <th mat-header-cell *matHeaderCellDef>
        Doctor
      </th>

      <td mat-cell *matCellDef="let row">

        {{ row.doctorName }}

      </td>

    </ng-container>

    <!-- TESTS -->

    <ng-container matColumnDef="tests">

      <th mat-header-cell *matHeaderCellDef>
        Tests
      </th>

      <td mat-cell *matCellDef="let row">

        <div class="test-pills">

          @for(test of (row.tests?.split('|') || []).slice(0,3); track $index){

          <span class="pill">
            {{ test }}
          </span>

          }

          @if((row.tests?.split('|') || []).length > 3){

          <span class="more">
            +{{ (row.tests?.split('|') || []).length - 3 }}
          </span>

          }

        </div>

      </td>

    </ng-container>

    <!-- STATUS -->

    <ng-container matColumnDef="status">

      <th mat-header-cell *matHeaderCellDef>
        Status
      </th>

      <td mat-cell *matCellDef="let row">

        <!-- <app-requisition-status-chip
          [status]="row.status"
          (click)="updateStatus(row)">
        </app-requisition-status-chip> -->

        <div class="status-chip" [ngClass]="getStatusClass(row.status)" (click)="statusUpdate.emit(row)">

          {{ getStatusLabel(row.status) }}

        </div>

      </td>

    </ng-container>

    <!-- DATE -->

    <ng-container matColumnDef="date">

      <th mat-header-cell *matHeaderCellDef>
        Date
      </th>

      <td mat-cell *matCellDef="let row">

        {{ row.date | date:'dd/MM/yyyy' }}

      </td>

    </ng-container>
    <!-- comment -->
    <ng-container matColumnDef="comment">

      <th mat-header-cell *matHeaderCellDef>
        Comment
      </th>

      <td mat-cell *matCellDef="let row">
        {{ row.comments || '-' }}
      </td>

    </ng-container>


    <!-- ACTIONS -->

    <ng-container matColumnDef="action">

      <th mat-header-cell *matHeaderCellDef>
        Action
      </th>

      <td mat-cell *matCellDef="let row">

        <div class="action-buttons">
          <button class="upload-action" (click)="uploadReport.emit(row)">
            <mat-icon>cloud_upload</mat-icon>
            Upload
          </button>

          <button class="req-action" (click)="createRequisition.emit(row)">

            <mat-icon>
              description
            </mat-icon>

            Requisition

          </button>

        </div>

      </td>

    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns">
    </tr>

    <tr mat-row *matRowDef="
      let row;
      columns: displayedColumns">
    </tr>

  </table>

  @if(!loading && requisitions.length === 0){

  <div class="empty-state">

    No Requisitions Found

  </div>

  }

</div>